import { ProjectStakeholderDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProjectStakeholderActions from './project-stakeholder.actions';

export const PROJECT_STAKEHOLDER_FEATURE_KEY = 'projectStakeholder';

export interface ProjectStakeholderState
  extends EntityState<ProjectStakeholderDto> {
  selectedProjectStakeholderId?: string | number; // which ProjectStakeholder record has been selected
  loaded: boolean; // has the ProjectStakeholder list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProjectStakeholderPartialState {
  readonly [PROJECT_STAKEHOLDER_FEATURE_KEY]: ProjectStakeholderState;
}

export const projectStakeholderAdapter: EntityAdapter<ProjectStakeholderDto> = createEntityAdapter<
  ProjectStakeholderDto
>({
  selectId: (projectStakeholder) => projectStakeholder.id,
  sortComparer: false,
});

export const initialState: ProjectStakeholderState = projectStakeholderAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProjectStakeholderId: null,
  }
);

const projectStakeholderReducer = createReducer(
  initialState,
  on(ProjectStakeholderActions.loadProjectStakeholder, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectStakeholderActions.loadProjectStakeholderSuccess,
    (state, { projectStakeholder }) =>
      projectStakeholderAdapter.addAll(projectStakeholder, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ProjectStakeholderActions.loadProjectStakeholderFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  on(ProjectStakeholderActions.addProjectStakeholder, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectStakeholderActions.addProjectStakeholderSuccess,
    (state, { newProjectStakeholder }) =>
      projectStakeholderAdapter.addMany(newProjectStakeholder, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ProjectStakeholderActions.addProjectStakeholderFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),

  on(ProjectStakeholderActions.updateProjectStakeholder, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectStakeholderActions.updateProjectStakeholderSuccess,
    (state, { updateProjectStakeholder }) =>
      projectStakeholderAdapter.upsertMany(updateProjectStakeholder, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ProjectStakeholderActions.updateProjectStakeholderFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  // search student

  on(
    ProjectStakeholderActions.searchProjectStakeholderRecord,
    (state, { query }) => {
      return {
        ...state,
        selectedProjectStakeholderId: query,
        loaded: false,
        error: null,
      };
    }
  ),
  on(ProjectStakeholderActions.removeProjectStakeholder, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectStakeholderActions.removeProjectStakeholderSuccess,
    (state, { ids }) =>
      projectStakeholderAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(
    ProjectStakeholderActions.removeProjectStakeholderFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  )
);

export function reducer(
  state: ProjectStakeholderState | undefined,
  action: Action
) {
  return projectStakeholderReducer(state, action);
}
